import { html, rune, type Html, View } from 'rune-ts';
import klass from './PortfolioSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { getResizedUrl } from '../../../../../shared/util/image';

const img_urls = {
  pc: '//s3.marpple.co/files/u_4648126/2024/10/original/6ffd74fff7e9ae1c19e78ebc148cc3d3db02932c1.webp',
  mo: '//s3.marpple.co/files/u_4648126/2024/10/original/401575108d3a221be552ca4c3c6a40f077cb58bc1.webp',
};

export class PortfolioSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    const texts = {
      portfolio_banner_title: html.preventEscape(
        ET(`mps2::landing::handmade::${is_mobile ? 'mo_' : ''}portfolio_banner_title`),
      ),
    };

    return html`
      <section class="${klass.portfolio}">
        <div class="${klass.banner}">
          <img
            class="${klass.banner_image}"
            src="${getResizedUrl({
              url: `${is_mobile ? img_urls.mo : img_urls.pc}`,
              width: 1920 * 2,
              format: 'webp',
              quality: 85,
            })}"
            alt="포트폴리오 섹션 배너 이미지"
          />
          <div class="${klass.content}">
            <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
              ${texts.portfolio_banner_title}
            </div>
          </div>
        </div>
      </section>
    `;
  }
}
